import { render, staticRenderFns } from "./wxInvite.vue?vue&type=template&id=ec1a8326&scoped=true"
import script from "./wxInvite.vue?vue&type=script&lang=js"
export * from "./wxInvite.vue?vue&type=script&lang=js"
import style0 from "./wxInvite.vue?vue&type=style&index=0&id=ec1a8326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1a8326",
  null
  
)

export default component.exports